@use "../../styles/colors";

:global {
  body[class*="theme-"].theme {
    :local {
      .container {
        font-size: 0.875rem;
        font-weight: 500;
        line-height: 1.375rem;
        padding: 0.25rem;
        border-radius: 0.25rem;
        color: colors.$mmc-primary;
        background-color: colors.$mmc-primary-010;

        &.greyed {
          color: colors.$mmc-disabled-gray;
          background-color: colors.$mmc-slate-010;
        }

        &.warn {
          color: colors.$mmc-slate;
          background-color: colors.$mmc-yellow-025;
        }
      }
    }
  }
}
